<!--  -->
<template>
  <div
    :class="{'foot':true,'p-foot':isPhone}"
    :style="isPhone?'':'align-items: center; height: 341px;  margin-top: 170px;'"
  >
    <div class="box" :style="isPhone?'height:auto':'height:270px'">
      <div class="top" :style="isPhone?'flex-direction: column;justify-content: space-between;':''">
        <img :src="'./static/img/home/foot-logo.png'" alt />
        <div class="right" :style="isPhone?'margin-bottom:20px;justify-content: space-between;':''">
          <div
            v-for="(item,index) in footData"
            :key="index"
            class="right-box"
            :style="isPhone ? (index == 0 ? 'margin-right:0' : 'margin-right:0')+';font-size:16px' : ''"
          >
            <h3
              :style="i.name ? 'cursor: pointer;':isPhone?'height:0px;':''"
              v-for="(i,j) in item"
              :key="j"
              @click="openLink(i.link)"
            >{{i.name}}</h3>
          </div>
        </div>
      </div>
      <p class="tip">
        <span>沪ICP备13033443号-1</span>
        <span style="min-width:100px;">互联网药品信息服务资格证书编号：(沪)-非经营性-2013-0062</span>
        <span class="last-item">沪公网安备 31010102003384号</span>
        <span v-if="!isPhone" class="last-item">©2018 波科国际医疗贸易（上海）有限公司版权所有</span>
      </p>
      <span v-if="isPhone" style="margin-top:20px;text-align:center">©2018 波科国际医疗贸易（上海）有限公司版权所有</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: '',
  computed: {
    ...mapGetters(['isPhone'])
  },
  data() {
    return {
      footData: {
        list1: [
          { 'name': '波士顿科学', 'link': 'http://www.bostonscientific.cn/' },
          { 'name': '', 'link': '' },
          { 'name': '波士顿科学专业教育', 'link': 'http://www.bostonscientific.cn/Institute' },
          { 'name': 'IAS 创新培训学院', 'link': 'http://www.bostonscientific.cn/collegeOverview' },
          { 'name': 'EDUCARE概览', 'link': 'http://www.bostonscientific.cn/EDUCAREHeart' }
        ],
        list2: [
          { 'name': '联系我们', 'link': 'http://www.bostonscientific.cn/contactus' },
          { 'name': '网站地图', 'link': 'http://www.bostonscientific.cn/' },
          { 'name': '使用条款和隐私政策', 'link': 'http://www.bostonscientific.cn/' },
          { 'name': '版权信息', 'link': 'http://www.bostonscientific.cn/' }
        ]
      }
    }
  },
  methods: {
    openLink(url) {
      if (url) window.open(url)
    }
  }
}
</script>
<style lang='less' scoped>
.foot {
  width: 100%;
  background-color: @foot-blue;
  display: flex;
  justify-content: center;
  padding: 0 20px;
  box-sizing: border-box;
  .box {
    box-sizing: border-box;
    padding-bottom: 10px;
    max-width: 1415px;
    width: 100%;
    color: #fff;
    font-family: 'SourceHanSansCN-Regular';
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .top {
      display: flex;
      justify-content: space-between;
      > img {
        .wh(auto, 113px);
      }
      .right {
        display: flex;
        .right-box {
          width: 181px;
          font-size: 20px;
          > h3 {
            margin-bottom: 10px;
            height: 20px;
          }
        }
        .right-box + .right-box {
          margin-left: 40px;
          > h3 {
            text-align: right;
          }
        }
      }
    }
    .tip {
      font-size: 15px;
      display: flex;
      > span {
        padding: 0 20px;
        border-right: 2px solid #fff;
      }
      .last-item {
        border: none;
      }
    }
  }
}
.p-foot {
  height: 450px;
  margin-top: 70px;
  .right-box + .right-box {
    margin: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gFooter.vue